<div class="modal-header border-0">
  @if (modalContentData.closeable) {
  <button type="button" class="btn-close" aria-label="Close" (click)="crossClickHandle()"></button>
  }
</div>
<div class="modal-body">
  @if (modalContentData) {
  <div class="d-grid gap-2 col-lg-12 col-md-12 mx-auto">
    <div class="col-md-auto">
      <h2 class="modal-title text-center animated fadeInDown">{{ modalContentData.title }}</h2>
      <div class="mobile-ios-top-pad"></div>
      @if (modalContentData.textContent) {
      <div class="text-center mt-2 animated fadeIn mb-5" #textContent></div>
      }
    </div>
  </div>
  }

  @switch (modalContentType) {

  @case (modalContentTypes.ACCOUNT_PAST_DUE) {
  <app-past-due-balance [pastDue]="modalContentData.pastDue"></app-past-due-balance>
  }

  @case (modalContentTypes.INVOICE_HISTORY) {
  <app-invoice-history [unpaidOnly]="!!modalContentData.invoiceHistory?.unpaidOnly" />
  }

  @case (modalContentTypes.CHECK_ADDRESS) {
  <app-check-address></app-check-address>
  <!-- <app-check-address-signup></app-check-address-signup> -->
  }
  @case (modalContentTypes.HOW_IT_WORKS) {
  <app-how-it-works [modalContentData]="modalContentData"></app-how-it-works>
  }

  @case (modalContentTypes.WELCOME_MESSAGE) {
  <app-welcome-message [modalContentData]="modalContentData"></app-welcome-message>
  }

  @case (modalContentTypes.SEND_INFORMATION) {
  <app-send-information [modalContentData]="modalContentData"></app-send-information>
  }

  @case (modalContentTypes.BOX_DETAIL) {
  <app-modal-box-detail [boxDetail]="modalContentData.boxDetail || null"></app-modal-box-detail>
  }
  @case (modalContentTypes.PAUSE_SUBSCRIPTION) {
  <app-pause-subscriptions [data]="modalContentData"></app-pause-subscriptions>
  }
  @case (modalContentTypes.CONFIRMATION) {
  <div class="d-flex justify-content-center gap-4 animated fadeInUp" [class.mt-5]="!modalContentData.textContent">
    @if (modalContentData.cancelButtonText) {
    <button type="button" class="btn btn-outline-secondary"
      (click)="confirmModalButtonsAction(false)">{{modalContentData.cancelButtonText}}</button>
    }
    @if (modalContentData.confirmButtonText) {
    <button type="button" class="btn btn-primary"
      (click)="confirmModalButtonsAction(true)">{{modalContentData.confirmButtonText}}</button>
    }
    @if (modalContentData.alternateButtonText) {
    <button type="button" class="btn btn-warning"
      (click)="alternateModalButtonAction()">{{modalContentData.alternateButtonText}}</button>
    }
  </div>
  }
  @case (modalContentTypes.SKIP_DELIVERY) {
  <app-skip-delivery></app-skip-delivery>
  }
  @case (modalContentTypes.BECOME_A_MEMBER) {
  <app-become-a-member [data]="modalContentData.becomeAMemeber"></app-become-a-member>
  }
  @case (modalContentTypes.BUY_AGAIN) {
  <app-buy-again-order-history
    [orderHistoryId]="modalContentData.buyAgain?.orderHistoryId"></app-buy-again-order-history>
  }
  @case (modalContentTypes.CHANGE_CREDENTIALS) {
  <app-change-credentials [email]="modalContentData.changeCredentials?.email || ''"></app-change-credentials>
  }

  @case (modalContentTypes.PROSPECT) {
  <app-prospect></app-prospect>
  }

  @case (modalContentTypes.PENDING_PAYMENT_METHOD) {
  <app-pending-payment-method></app-pending-payment-method>
  }

  @case (modalContentTypes.PENDING_PAYMENT_METHOD_NO_SIGNUP) {
  <app-pending-payment-method-no-signup></app-pending-payment-method-no-signup>
  }

  @case (modalContentTypes.MEMBERSHIP_CSA_DEPOSITS) {
  <app-membership-csa-deposit></app-membership-csa-deposit>
  }

  @case (modalContentTypes.DONATION_SKIPPABLE) {
  <app-donation-skippable></app-donation-skippable>
  }

  @case (modalContentTypes.DONATION) {
  <app-donation></app-donation>
  }

  @case (modalContentTypes.TIP) {
  <app-tip></app-tip>
  }

  @case (modalContentTypes.DELETE_TIP_AND_DONATION) {
  <app-delete-tip-donation></app-delete-tip-donation>
  }

  @case (modalContentTypes.HOLD_UP_UPDATE_SUBSCRIPTION) {
  <app-hold-up-subscriptions></app-hold-up-subscriptions>
  }

  @case (modalContentTypes.BUY_AGAIN_WARNING) {
  <app-buy-again-order-history-warning
    [products]="modalContentData.orderHistoryWarning || {products: [], showThirdColumn: true, fromOrder: false}"></app-buy-again-order-history-warning>
  }

  @case (modalContentTypes.PAST_CUT_OFF) {
  <app-past-cut-off></app-past-cut-off>
  }

  @case (modalContentTypes.CHECK_SUBMIT_ORDER) {
  <app-check-submit-order></app-check-submit-order>
  }

  @case (modalContentTypes.ACCOUNT_SUSPENDED) {
  <app-suspended-account></app-suspended-account>
  }

  @case (modalContentTypes.SELECT_DELIVERY_DAY) {
  <app-delivery-day-selection
    [zoneId]="modalContentData.deliveryDaySelection?.zoneId || 0"></app-delivery-day-selection>
  }

  @case (modalContentTypes.SUBSCRIPTION_NEXT_DELIVERY) {
  <app-subscription-next-delivery
    [availableDates]="modalContentData.subscriptionNextDelivery?.availableDates || []"></app-subscription-next-delivery>
  }

  @case (modalContentTypes.PRODUCT_SUBSCRIPTION) {
  <app-product-subscription [productSubsInfo]="modalContentData.productSubscription"></app-product-subscription>
  }

  @case (modalContentTypes.PREORDER_PRODUCT) {
  <app-pre-order-product [data]="modalContentData.preOrderProduct"></app-pre-order-product>
  }

  @case (modalContentTypes.DISLIKE_PRODUCT_CONFIRMATION) {
  <app-dislike-confirmation></app-dislike-confirmation>
  }

  @case(modalContentTypes.BUNDLES_SUBSCRIPTION) {
  <app-bundles-subscription></app-bundles-subscription>
  }

  @case (modalContentTypes.RESCHEDULED_ORDER) {
  <app-rescheduled-orders [orders]="modalContentData.rescheduledOrders"></app-rescheduled-orders>
  }

  @case (modalContentTypes.RESUME_SUBSCRIPTION) {
  <app-resume-subscriptions [data]="modalContentData.resumeSubscriptions"></app-resume-subscriptions>
  }

  @case (modalContentTypes.BUNDLE_SUBSTITUTION) {
  <app-bundle-substitution [items]="modalContentData.bundleSubstitutions ?? []"
    [isSubstitution]="!!modalContentData.isSubstitution"></app-bundle-substitution>
  }

  @case (modalContentTypes.AUTH_NET_PURCHASE) {
  <app-auth-net-purchase [purchaseReqAddFields]="modalContentData.authNetPurchase"></app-auth-net-purchase>
  }

  @case (modalContentTypes.NMI_PURCHASE) {
  <app-nmi-purchase [purchaseReqAddFields]="modalContentData.nmiPurchase"></app-nmi-purchase>
  }

  @case (modalContentTypes.DISLIKE_FAV) {
  <app-dislike-fav [preferences]="modalContentData.preferences ?? {dislikes: [], likes: []}"></app-dislike-fav>
  }

  @case (modalContentTypes.CHANGE_QUANTITY_SUBSCRIPTION) {
  <app-change-quantity-subscription [quantity]="modalContentData.quantity ?? 0"></app-change-quantity-subscription>
  }

  @case (modalContentTypes.CHECK_SUBMIT_BUNDLE_CHANGES) {
  <app-check-submit-bundle-changes></app-check-submit-bundle-changes>
  }

  @case (modalContentTypes.FARMBOX_SUBSCRIPTION) {
  <app-farmbox-subscription [categoryId]="modalContentData.categoryId ?? 0"></app-farmbox-subscription>
  }

  @case (modalContentTypes.SUGGESTED_PRODUCTS) {
  <app-suggested-products [productsSource]="modalContentData.suggestedProducts!"></app-suggested-products>
  }

  @case (modalContentTypes.AFTER_BUNDLE_ADDED) {
  <app-after-bundle-added [product]="modalContentData.afterBundleAdded!.product!"
    [isSubscription]="modalContentData.afterBundleAdded!.isSubscription!"></app-after-bundle-added>
  }

  @case (modalContentTypes.NEW_CHECKOUT_FLOW) {
  <app-new-checkout-disclaimer></app-new-checkout-disclaimer>
  }

  @case (modalContentTypes.UNABLE_TO_CANCEL_SUBSCRIPTION) {
  <app-unable-to-cancel-subscription
    [retentionCoupons]="modalContentData.retentionCoupons!"></app-unable-to-cancel-subscription>
  }

  @case (modalContentTypes.SELECT_TERRITORY) {
  <app-select-territory></app-select-territory>
  }

  @case (modalContentTypes.PAYMENT_METHOD) {
  @if (paymentMethodComponentRef) {
  <ng-container *ngComponentOutlet="paymentMethodComponentRef; inputs: { inModal: true }"></ng-container>
  }
  }

  @case (modalContentTypes.DELIVERIES) {
  @if (deliveriesComponentRef) {
  <ng-container *ngComponentOutlet="deliveriesComponentRef; inputs: { inModal: true }"></ng-container>
  }
  }

  }
</div>